import { Avatar, Stack, Typography } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { EntitlementCategory } from './EntitlementCategory';
import { ClockNoBGIcon, PurpleDateIcon, RegularCalendar } from 'Images';
import { format } from 'date-fns/esm';
import { useIsDesktop } from 'Hooks';
import { slashDateFormat } from 'Config';

interface IEntitlementHeader {
  automatic: boolean;
  oneTime: boolean;
  title: string;
  filteredCategories: {
    category: string;
    subCategory: string;
  };
  lastDateUse?: Date;
  eligibleFrequency: string;
}

export const EntitlementHeader = ({
  automatic,
  oneTime,
  title,
  filteredCategories,
  lastDateUse,
  eligibleFrequency,
}: IEntitlementHeader) => {
  const isDesktop = useIsDesktop();

  return (
    <Stack
      margin='0 0 7px 0'
      alignItems='start'
      direction={isDesktop ? 'column' : 'column-reverse'}
      gap={isDesktop ? '16px' : undefined}
    >
      <Stack
        direction={isDesktop ? 'row' : 'column'}
        alignItems={isDesktop ? 'center' : 'right'}
        gap={isDesktop ? '' : '10px'}
        flexWrap='wrap'
      >
        <Typography variant={'body1'} margin='7px 24px 7px 0'>
          {title}
        </Typography>
        {filteredCategories.category && (
          <EntitlementCategory
            category={filteredCategories.category}
            automatic={automatic}
            oneTime={oneTime}
          />
        )}
      </Stack>
      <Stack direction='row' gap='32px'>
        {lastDateUse && (
          <Stack
            direction='row'
            alignItems='center'
            gap={'6px'}
            marginBottom={'5px'}
          >
            <Avatar
              src={RegularCalendar}
              alt={''}
              sx={{ width: '20px', height: '20px' }}
            />
            <Typography variant={'body6'}>
              {Dictionary[DICTIONARY.CompassRights].entitlements.lastUsageDate}{' '}
              {format(new Date(lastDateUse), slashDateFormat)}
            </Typography>
          </Stack>
        )}
        {eligibleFrequency && (
          <Stack
            direction='row'
            width='fit-content'
            alignItems='center'
            gap='7px'
          >
            <Avatar
              src={ClockNoBGIcon}
              alt={''}
              sx={{
                width: isDesktop ? '18px' : '15px',
                height: isDesktop ? '18px' : '15px',
              }}
            />
            <Typography
              color='#1752AF'
              fontWeight={400}
              fontSize={isDesktop ? '16px' : '14px'}
            >
              {Dictionary[DICTIONARY.CompassRights].entitlements.nextDateUse}
              {eligibleFrequency}
            </Typography>
          </Stack>
        )}
      </Stack>
    </Stack>
  );
};
